define('caccountPreconfItemStatusTabController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'caccountPreconfItemStatusTabView',
  'orderStatusCreateEditLayoutView',
  'entities/caccounts/orderstatus'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  CreateEditLayoutView
) {
  'use strict';

  var statusTabController = {
    showTab: function(data) {
      this.secId = data.type === 'customer' ? data.id : null;
      this.data = data;

      this.view = new View();

      this.view.listenTo(this.view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
      this.view.listenTo(this.view, 'onCreateStatus', _.bind(this.onCreateStatus, this));
      this.view.listenTo(this.view, 'onDelete', _.bind(this.onDeleteStatus, this));

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('tabContent').show(this.view);
    },

    onGridLoaded:function() {
      var data = {
          url: App.request('orderstatus-tab:get-url', this.secId, 'corporateTemplate'),
          rowCountUrl: App.request('orderstatus-tab:row-count-url', this.secId, 'corporateTemplate'),
          type: this.data.type
        };

      this.view.displayGrid(data, true);
    },

    onCreateStatus: function() {
        var createEditView = new CreateEditLayoutView({
            orderStatusModel: App.request('orderstatus-tab:new-model', {tag: 'corporateTemplate'}),
            newItem: true
        });
        createEditView.show({
            title: _.i18n('preconf-item-status.new')
        });
    },

    onDeleteStatus: function(id) {
      var that = this,
        deleteRequest;

      bootbox.confirm(_.i18n('warning.deleteOfferStatus'), function (result) {
        if (result) {
          deleteRequest = App.request('orderstatus-tab:delete', id);
          $.when(deleteRequest).done(function() {
            that.view.updatePagination('reloadGrid');
          });
        }
      });
    }
  };

  module.exports = statusTabController;
});

